import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, tap } from 'rxjs/operators';
import * as PlatformIdentityActions from './platform-identity.actions';

@Injectable()
export class PlatformIdentityEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);

  /**
   * On a failed validation (non-admin, bad token, backend error), send the user
   * to the welcome screen with the error surfaced via query param.
   */
  validateFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PlatformIdentityActions.validateFailed),
        tap(({ error }) => {
          this.router.navigate(['/welcome'], {
            queryParams: { authError: encodeURIComponent(error) },
          });
        })
      ),
    { dispatch: false }
  );

  /**
   * Once an admin session is established, move off the welcome screen into the
   * app. Only navigates when currently on /welcome so token refreshes that
   * re-dispatch setAdmin mid-session don't yank the user back to the dashboard.
   */
  adminEstablished$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PlatformIdentityActions.setAdmin),
        filter((action) => !!action.admin),
        tap(() => {
          if (this.router.url.startsWith('/welcome')) {
            this.router.navigate(['/']);
          }
        })
      ),
    { dispatch: false }
  );
}
